import { render, staticRenderFns } from "./ReservationContacts.vue?vue&type=template&id=75a3c14c"
import script from "./ReservationContacts.vue?vue&type=script&lang=js"
export * from "./ReservationContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports